"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KpiAtmosphereTypes;
(function (KpiAtmosphereTypes) {
    KpiAtmosphereTypes["CO2"] = "co2";
    KpiAtmosphereTypes["COV"] = "cov";
    KpiAtmosphereTypes["HUMIDITY"] = "humidity";
    KpiAtmosphereTypes["LUMINOSITY"] = "luminosity";
    KpiAtmosphereTypes["TEMPERATURE"] = "temperature";
})(KpiAtmosphereTypes = exports.KpiAtmosphereTypes || (exports.KpiAtmosphereTypes = {}));
